import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import FullInfoField from 'components/FullInfoField/FullInfoField';

interface IProps {
	charityAmountNumber: 0 | 1 | 2 | 3;
}

export const CharityAmountField: React.FC<IProps> = ({ charityAmountNumber }) => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);
	const charityAmount = restaurantForFullInfo?.charityAmounts?.[charityAmountNumber];

	return (
		<FullInfoField
			label={
				charityAmount?.isDefault
					? `charityAmount${charityAmountNumber}DefaultLabel`
					: `charityAmount${charityAmountNumber}Label`
			}
			value={charityAmount?.amount ?? null}
		/>
	);
};
